import { render, staticRenderFns } from "./moreCL.vue?vue&type=template&id=b31acab8&lang=pug&"
import script from "./moreCL.vue?vue&type=script&lang=js&"
export * from "./moreCL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports